import { Input, makeStyles, tokens, InputProps } from '@fluentui/react-components';
import { FC } from 'react';

const useStyles = makeStyles({
    syInput: {
        width: '100%',
        borderRadius: '0.5rem',
        background: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        boxShadow: 'none !important',
        '& .fui-Input__input': {
            boxShadow: 'none !important',
            '::placeholder': {
                color: tokens.colorNeutralForeground3,
            },
        },
        '&:focus-within': {
            outline: '2px solid var(--color-primary-400) !important',
            outlineOffset: '2px !important',
            border: `1px solid ${tokens.colorNeutralStroke2} !important`,
            boxShadow: 'none !important',
            background: `${tokens.colorNeutralBackground1} !important`,
        },
        '&::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
        '& .fui-Input__input:focus::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
        '& .fui-Input__input:focus + div::after': {
            display: 'none !important',
        },
        '&:focus-within::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
    },
});

export const SyInput: FC<InputProps> = (props) => {
    const classes = useStyles();
    
    return (
        <Input
            {...props}
            className={`${classes.syInput} ${props.className || ''}`}
        />
    );
};
